import m, {Vnode} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import CustomForm from "../../CustomForm";
import Carousel from "../../shared/components/Carousel/Carousel";
import {CheckboxItem} from "../../../model/items/checkbox";
import {ImageItem} from "../../../model/items/imageItem";
import TCarouselSetting from "../../shared/components/Carousel/TCarouselSetting";

export default class CarouselDefault extends CustomForm {

    private carousel: Carousel;


    public constructor(settings: ICustomFormSettings) {
        super(settings);


        const validationCheckbox = settings.form.grid.layout[0][0].cellItems[0];

        this.carousel = new Carousel(
            this.getCarouselSettings(),
            validationCheckbox instanceof CheckboxItem ? validationCheckbox : null,
            settings.form.questionary
        );

    }

    private getCarouselSettings(): TCarouselSetting {
        try {
            const aux1 = this.settings.form.aux1;
            const carouselSetting = aux1 ? JSON.parse(aux1) : null;
            if (carouselSetting) {
                return carouselSetting;
            }
            console.log('customForm-Carousel-default: Definition in AUX1 not found, skip.');
        } catch (err) {
            console.warn('customForm-Carousel-default: Unable to parse JSON with settings from AUX1.');
        }


        const images = <ImageItem[]>this.settings.form.grid.cellItems.filter(ci => ci instanceof ImageItem);

        return {
            images: images.map(image => this.settings.form.questionary.getFileUrl(image.file))
        }
    }


    checkRequirements(): boolean {
        if (this.carousel.setting.images.length < 1) {
            console.log("customForm-Carousel-default: Carousel has not images. Check aux1 json or put images directly to form.");
            return false;
        }
        return true;
    }

    view(): Vnode {
        return this.viewLayout( m(this.carousel) );
    }

}